import {PunkRocker} from "../../../PunkRocker";
import {GameConfig} from "../../../config/base/GameConfig";

export class TrainState {

    public static TRAIN_ENTER: string = "train_enter";
    public static TRAIN_LOOP: string = "train_loop";
    public static TRAIN_STOP_OPEN: string = "train_stop_open";
    public static TRAIN_CLOSE_EXIT: string = "train_close_exit";
    public static TRAIN_OPEN_ONLY: string = "train_open";
    public static TRAIN_OPEN_LOOP: string = "train_open_fire_loop";

    public static TOP_CART_MODE: string = "";
    public static BOTTOM_CART_MODE: string = "";
    private static iconLinks: Map<string, string> = new Map([
        ["BLANK", "Dead/Dead_Spray"],
        ["X2", "Train_Icons/x2"],
        ["X3", "Train_Icons/x3"],
        ["X5", "Train_Icons/x5"],
        ["X10", "Train_Icons/x10"],
        ["B_X10", "Train_Icons/B_x10"],
        ["X15", "Train_Icons/x15"],
        ["B_X15", "Train_Icons/B_x15"],
        ["X25", "Train_Icons/x25"],
        ["B_X25", "Train_Icons/B_x25"],
        ["X50", "Train_Icons/x50"],
        ["B_X50", "Train_Icons/B_x50"],
        ["X75", "Train_Icons/x75"],
        ["B_X75", "Train_Icons/B_x75"],
        ["X100", "Train_Icons/x100"],
        ["B_X100", "Train_Icons/B_x100"],
        ["BJW", "Train_Icons/BJW"],
        ["UPGRADE", "Train_Icons/Jumping_Wild"],
        ["6X6", "Train_Icons/6x6"],
        ["PLUS_1", "Train_Icons/Retrigger1"],
        ["XWAYS_FS", "Train_Icons/X_Ways"],
        ["ENABLE_TRAIN", "Train_Icons/Train"],
        ["MOLOTOV_FS", "Train_Icons/Wild"],
    ])

    public static setCartMode(trainType: string, textures: PIXI.Texture[] & undefined[]): void {
        if (trainType === "topTrain") {
            this.TOP_CART_MODE = "";

            let leftSide: boolean = false,
                rightSide: boolean = false;

            for (let t: number = 0; t < textures.length; t++) {
                if (textures[t] == undefined) continue;
                if (t <= 2) leftSide = true;
                else if (t > 2) rightSide = true;
            }

            if (rightSide) {
                this.TOP_CART_MODE = leftSide ? "_LR" : "_R";
            }
        } else {
            this.BOTTOM_CART_MODE = "";

            let isLeft: boolean = false,
                isMiddle: boolean = false,
                isRight: boolean = false;

            for (let t: number = 0; t < textures.length; t++) {
                if (textures[t] == undefined) {
                    continue;
                }

                if (t <= 1) isLeft = true;
                if (t > 1 && t <= 3) isMiddle = true;
                if (t > 3) isRight = true;
            }

            if (!isLeft && isMiddle && !isRight) {
                this.BOTTOM_CART_MODE = "_M";
            } else if (!isLeft && !isMiddle && isRight) {
                this.BOTTOM_CART_MODE = "_R";
            } else if (isLeft && isMiddle && !isRight) {
                this.BOTTOM_CART_MODE = "_LM";
            } else if (!isLeft && isMiddle && isRight) {
                this.BOTTOM_CART_MODE = "_MR";
            } else if (isLeft && !isMiddle && isRight) {
                this.BOTTOM_CART_MODE = "_LR";
            } else if (isLeft && isMiddle && isRight) {
                this.BOTTOM_CART_MODE = "_LMR";
            } else {
                this.BOTTOM_CART_MODE = "";
            }
        }
    }

    /*public static getTextures(state: string): PIXI.Texture[] {
        if (state == this.INTRO || state == this.TRAVEL) {
            if (state == this.TRAVEL) {
                state = this.TRAVEL;
                return PunkRocker.assetLoader.getTextures(state);
            }
            return PunkRocker.assetLoader.getTextures(state);
        }

        let cartMode: string = state.includes("topTrain") ? this.TOP_CART_MODE : this.BOTTOM_CART_MODE;

        if (state.includes("bottomTrain") && (state.includes("Train_Intro") || state.includes("Train_Travel") || state.includes("Train_Travel_Green"))) {
            cartMode = "";
        }

        state = state.split("/")[0] + "/" + state.split("/")[1] + "/" + state.split("/")[2] + cartMode + "/" + state.split("/")[3];
        return PunkRocker.assetLoader.getTextures(state);
    }*/

    public static getIcons(trainType: string, trainValues: string[] = []): PIXI.Texture[] & undefined[] {
        let textures: PIXI.Texture[] & undefined[] = [];
        for (let i: number = 0; i < trainValues.length; i++) {
            if (this.iconLinks.has(trainValues[i])) {
                if (trainValues[i] === "BLANK") {
                    textures.push(undefined);
                } else {
                    if (trainType === "bottomTrain" && GameConfig.BOTTOM_TRAIN_MULT.includes(trainValues[i])) {
                        if (PunkRocker.model.gameData.raw.burningTrain.includes(true)) {
                            if ((PunkRocker.model.gameData.raw.burningTrain[0] && (i === 0 || i === 1))
                                || (PunkRocker.model.gameData.raw.burningTrain[1] && (i === 2 || i === 3))
                                || (PunkRocker.model.gameData.raw.burningTrain[2] && (i === 4 || i === 5))) {
                                trainValues[i] = "B_" + trainValues[i];
                            }
                        }
                    }
                    textures.push(PunkRocker.assetLoader.getTextures(this.iconLinks.get(trainValues[i])!)[0]);
                }
            }
        }
        this.setCartMode(trainType, textures);
        return textures;
    }

    public static getAnimName(state: string): string {
        let animName: string;

        switch (state) {
            case TrainState.TRAIN_ENTER:
                animName = TrainState.TRAIN_ENTER;
                break;
            case TrainState.TRAIN_STOP_OPEN:
                animName = TrainState.TRAIN_STOP_OPEN;
                break;
            case TrainState.TRAIN_CLOSE_EXIT:
                animName = TrainState.TRAIN_CLOSE_EXIT;
                break;
            case TrainState.TRAIN_OPEN_ONLY:
                animName = TrainState.TRAIN_OPEN_ONLY;
                break;
            case TrainState.TRAIN_OPEN_LOOP:
                animName = TrainState.TRAIN_OPEN_LOOP;
                break;
            default:
                animName = TrainState.TRAIN_LOOP;
                break;
        }

        return animName;
    }
}